import { render, staticRenderFns } from "./BackClient.vue?vue&type=template&id=45a7b048&scoped=true"
import script from "./BackClient.vue?vue&type=script&lang=js"
export * from "./BackClient.vue?vue&type=script&lang=js"
import style0 from "./BackClient.vue?vue&type=style&index=0&id=45a7b048&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7b048",
  null
  
)

export default component.exports